<!--
    Program: RequestImeiPwdUpdate.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">IMEI Password Update</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile SVC
                <em>
                    <span class="sr_only">&gt;</span>
                </em>IMEI Password Update
            </div>
            <!-- //breadcrumbs -->

            <!-- detail_Information -->
            <table class="create_table">
                <colgroup>
                    <col width="16%" />
                    <col width="40%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Previous ESN/IMEI Writing P/W</th>
                        <td>
                            <span>
                                <input
                                    type="password"
                                    class="text_input w100"
                                    minlength="8"
                                    maxlength="20"
                                    placeholder
                                    v-model="prevImeiPwd"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                        <td>
                        </td>
                    </tr>
                    <tr>
                        <th>New ESN/IMEI Writing P/W</th>
                        <td>
                            <span>
                                <input
                                    type="password"
                                    class="text_input w100"
                                    minlength="8"
                                    maxlength="20"
                                    placeholder
                                    v-model="imeiPwd"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                        <td>
                            <a @click="showPasswordRules" href="javascript:">
                                <span class="ico_sech_sm">search아이콘</span>
                                View Password Rules
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th>New ESN/IMEI P/W Confirm</th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="password"
                                    class="text_input w100"
                                    minlength="8"
                                    maxlength="20"
                                    placeholder
                                    v-model="imeiPwdConfirm"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail_Information -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <div class="btn_right">
                    <a @click="onUpdateClick" class="btn_blue" title>Update</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil, DateUtil } from '@/utils';

// import DatePicker from '~c/DatePicker';

// import HhpCerts from '~c/HhpCerts';

export default {
    name: 'hhp-imei-pwd-update',
    components: {},
    props: [],
    computed: {
    },
    data() {
        return {
            prevImeiPwd: '',
            imeiPwd: '',
            imeiPwdConfirm: '',

            // Initially fetched data
            prevImeiPwdEncrypted: '',
            type_cd: '',
            change_country_cd: '',
            change_role_cd: '',
            G_LOGIN_PWD: '',

            ename: '',
            email: '',
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchInitData()
            this.setInitData(data);

            SDLUtil.showLoadingBar(false);

            SDLUtil.alert({
                title: 'IMEI Password Update',
                msg: 'Your IMEI Password has expired. Please update the password.',
            });
        },
        fetchInitData() {
            const path = '/basis/anysvcmobile/request/RequestImeiPwdUpdate.skp';
            return SDLUtil.getRequest(path);
        },

        setInitData(data) {
            data.userData = data.userData[0];
            console.log('RECDATA', data.userData);

            this.change_country_cd = data.userData.COUNTRY_CD;
            this.change_role_cd = data.userData.ROLE_CD;
            this.type_cd = data.userData.TYPE_CD;

            this.G_LOGIN_PWD = data.userData.G_LOGIN_PWD;
            this.prevImeiPwdEncrypted = data.userData.IMEI_PASS;

            this.email = data.userData.EMAIL;
            this.ename = data.userData.ENAME;
        },

        onUpdateClick() {
            this.submitForm();
        },

        async submitForm() {
            if (!this.validateFormData()) return;
            const formData = this.prepFormData();
            SDLUtil.showLoadingBar(true);

            const path = '/basis/anysvcmobile/request/RequestImeiPwdUpdateProc.skp';
            const data = await SDLUtil.postForm(path, formData)
                .catch(err => {
                    if (err.data.error.code === 'HHP_INVALID_REQUEST') {
                        SDLUtil.alert({
                            title: 'Request Failed!',
                            msg: 'Failed to update the IMEI Password.<br> '+err.data.error.message+'<br>Please try again.',
                        });
                    }
                    return false;
                });
            SDLUtil.showLoadingBar(false);

            if (data === false || !data.result) {
                SDLUtil.alert({
                    title: 'Request Failed!',
                    msg: 'Failed to update the IMEI Password.<br>Please try again.',
                });
                return;
            }

            SDLUtil.alert({
                title: 'Success!',
                msg: 'IMEI Password has been updated. Please continue.',
                okLabel: 'Continue',
                onOkEvt: () => {
                    const path = localStorage.getItem('hhp_redirect');
                    if (path) {
                        localStorage.removeItem('hhp_redirect');
                        this.$router.push({ path });

                    } else {
                        this.$router.push({ name: 'anysvcCertHome' });

                    }
                    this.$router.push({ path });
                },
            });
        },

        validateFormData() {
            if (this.prevImeiPwd.length < 10) {
                SDLUtil.alert({
                    title: 'ESN/IMEI Password',
                    msg: 'Previous Password needs to be 10 or longer.',
                });
                return false;
            }

            if (this.imeiPwd !== this.imeiPwdConfirm) {
                SDLUtil.alert({
                    title: 'ESN/IMEI Password',
                    msg: 'Passwords not matching.',
                });
                return false;
            }

            if (!this.validateImeiPwd(this.imeiPwd, '', this.email, this.ename)) {
                return false;
            }

            return true;
        },

        validateImeiPwd(pwd, loginId = '', email = '', name = '') {
            const strNewPwd = pwd;
            const strUserID = loginId;
            const strEmail = email;

            // PART
            const strName = name;
            const nowDate = new Date();
            const year = String(nowDate.getYear());
            const year_prev = String(nowDate.getYear() - 1);
            const year_next = String(nowDate.getYear() + 1);

            let strEmailId = '';
            let strEmailCompany = '';

            const idx_email_id = email.indexOf('@');
            if (idx_email_id > -1) {
                strEmailId = email.substring(0, idx_email_id);
                const idx_email_company = email.indexOf('.');
                if (idx_email_company > -1) {
                    strEmailCompany = email.substring(idx_email_id + 1, idx_email_company);
                }
            }

            // FULL
            const FORBIDDEN_WORDS = [
                strUserID.toUpperCase(),
                strName.toUpperCase(),
                'SAMSUNG',
                'GSPN',
                'SERVICE',
                'SERVICIO',
                'IMEI',
                'ESN',
                'PASSWORD',
                year,
                year_prev,
                year_next,
                strEmailId.toUpperCase(),
                strEmailCompany.toUpperCase(),
                '1QAZXSW23E',
                '12QWERASDF',
                '12QWASZX3E',
                'ASDFQWER12',
                'ASDF',
                'QWER',
                'ZXCV',
            ];

            const RULES = [
                {
                    condition: pwd => !pwd,
                    msg: 'The ESN/IMEI password is required.',
                },
                {
                    condition: pwd => pwd.length < 10,
                    msg: 'The password must be 10 or longer.',
                },
                {
                    condition: pwd => !pwd.match(/(.[a-zA-Z].[0-9])|(.[0-9].[a-zA-Z])/),
                    msg: 'The password must be alphanumeric.',
                },
                {
                    condition: pwd => pwd.match(/([&,%,>,<,',",;,},{,|])/),
                    msg: 'The password cannot contain the following special characters. e.g. & % > < \' " ; } { |',
                },
                {
                    condition: pwd => !pwd.match(/([!,@,#,$,^,*,?,_,~])/),
                    msg: 'The password must contain one of the following special characters. e.g. ! @ # $ ^ * ? _ ~',
                },
                {
                    condition: pwd => {
                        const pwdUpperCase = pwd.toUpperCase();
                        for (var i = 0; i < FORBIDDEN_WORDS.length; i++) {
                            if (!FORBIDDEN_WORDS[i]) continue;
                            if (pwdUpperCase.includes(FORBIDDEN_WORDS[i])) {
                                return `The password cannot contain a word "${FORBIDDEN_WORDS[i]}"`;
                            }
                        }
                        return false;
                    },
                    msg: '',
                },
                {
                    condition: pwd => {
                        let samePwd_0 = 0; //동일문자 카운트
                        let samePwd_1 = 0; //연속성(+) 카운트
                        let samePwd_2 = 0; //연속성(-) 카운트

                        let chr_pass_0, chr_pass_1, chr_pass_2, chr_pass_3;
                        const pwdLength = pwd.length;

                        for (let i = 0; i < pwdLength; i++) {
                            chr_pass_0 = pwd.charAt(i);
                            chr_pass_1 = pwd.charAt(i + 1);
                            chr_pass_2 = pwd.charAt(i + 2);
                            chr_pass_3 = pwd.charAt(i + 3);

                            //동일문자 카운트
                            if (chr_pass_0 == chr_pass_1 && chr_pass_0 == chr_pass_2 && chr_pass_0 == chr_pass_3) {
                                samePwd_0++;
                            }

                            //연속성(+) 카운드
                            if (
                                chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == 1 &&
                                chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == 1
                            ) {
                                samePwd_1++;
                            }

                            //연속성 역순(-) 카운드
                            if (
                                chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == -1 &&
                                chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == -1
                            ) {
                                samePwd_2++;
                            }
                        }
                        if (samePwd_0 > 0) {
                            return 'A repetition of 3 consecutive characters or more is not permitted. (i.e. 1111, aaaa).';
                        }

                        if (samePwd_1 > 0 || samePwd_2 > 0) {
                            return 'No more than 3 consecutive numbers or characters. (i.e. 123, bca).';
                        }

                        return false;
                    },
                    msg: '',
                },
            ];

            const title = 'Password Rule';
            const isValid = RULES.every(rule => {
                const isInvalid = rule.condition(strNewPwd); // isInvalid: Boolean | String
                if (isInvalid) {
                    const msg = typeof isInvalid === 'string' ? isInvalid : rule.msg;
                    SDLUtil.alert({ title, msg });
                    return false; // Stops the loop
                }
                return true;
            });

            return isValid;
        },

        prepFormData() {
            const formData = {
                imei_pass: this.prevImeiPwdEncrypted,
                old_imei_pass: this.prevImeiPwd,
                change_imei_pass: this.imeiPwd,
                G_LOGIN_PWD: this.G_LOGIN_PWD, // GSPN Pwd Encrypted
                type_cd: this.type_cd,
                change_country_cd: this.change_country_cd,
                change_role_cd: this.change_role_cd,
                purpose: '',
            };
            console.log('FORMDATA', formData);
            return formData;
        },

        showPasswordRules() {
            let str = "1) The password's minimum length is 10<br>";
            str += '2) The password must be different from the previous<br>';
            str += '3) The password must contain the special character ! @ # $ ^ * ? _ ~<br>';
            str += '4) No more than 3 consecutive numbers or characters<br>';
            str += '5) The password cannot contain the user ID<br>';
            str += '6) A repetition of 3 consecutive characters or more is not permitted<br>';
            str += '7) The password must contain alphanumeric character';
            SDLUtil.alert({
                title: 'Password Rules',
                msg: str,
            });
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/request/RequestImeiPwdUpdate.vue